module.exports = __webpack_public_path__ + "static/media/anc12ru.839a33fa.pdf";